import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useRestClient } from "@/lib/restClient";
import { clearDashboardDraftForRecord } from "@/pages/workspace/dashboardDraft";

export function useDeleteDashboard() {
  const apiFetch = useRestClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) =>
      apiFetch(`/api/dashboards/${id}`, {
        method: "DELETE",
      }),
    onSuccess: (_result, id) => {
      clearDashboardDraftForRecord(id);
      clearDashboardDraftForRecord(id, "template");
      void queryClient.invalidateQueries({ queryKey: ["dashboards"] });
    },
  });
}
